import { productList } from "@/lib/product"
import axios from "@/utils/axios"
import { create } from "zustand"


interface IObj {
    [key: string]: any
}

interface Review {
  rating: number;
  name: string;
  comment: string;
}
interface IProduct {
    pdt_nm: string
    price: string
    currency: string
    spl_prc: string
    disc: string
    disc_typ: string
    spl_prc_in_num: number
    slug: string
    thumbnail: string
    rating: number
    total_sold: number
    pdt_id: string
    path: string
    max_order_quantity: number
    variants: IObj[]
    tags: IObj[]
    in_stk: boolean
}
interface IProductObj extends IProduct {
    [key: string]: any
}

type States = {
    productList: IProductObj[]
    productMetadata: IObj
    productReviews: Review[]

}


type Actions = {
    fetchProducts: (data?: IObj) => Promise<IObj>
    loadMoreProducts: (data?: IObj) => Promise<IObj>
    fetchReviews: (pdt_id: string) => Promise<IObj>
}

const useProductStore = create<States & Actions>((set, get) => ({
    productList: [],
    productMetadata: {},
    productReviews: [],
    fetchProducts: async (doc?: IObj) => {
        let result = await productList(doc)
        if (result.status) {
            set({ productList: result?.data?.data?.list || [], productMetadata: result?.data?.metadata || {} })
        }
        return result
    },
    loadMoreProducts: async (doc?: IObj) => {
        let result = await productList(doc)
        if (result.status) {
            set({ productList: [...get().productList, ...result?.data?.data?.list || []], productMetadata: result?.data?.metadata || {} })
        }
        return result
    },
    fetchReviews: async (pdt_id: string) => {
        try {
            let result = await axios.get(`${process.env.NEXT_PUBLIC_BOOKING_SERVICE}/rate-and-review/product-reviews?pdt_id=${pdt_id}`)
            if (result?.data?.status) {
                set({ productReviews: result?.data?.data || [] })
                return { status: true, data: result?.data, message: result?.data?.message }
            } else {
                return { status: true, error: result?.data?.error || result?.data?.message }
            }
        } catch (error: any) {
            return { status: true, error: error.message }
        }

    }
}))


export default useProductStore